import { Component, OnInit, ViewChild } from '@angular/core';

import { PageAction } from '../../components/page-actions/page-actions.component';
import { Router } from '@angular/router';
import { DashboardMessagesService } from '@services/dashboard-messages/dashboard-messages.service';
import { DataTableComponent, DataTableEvent } from '../../components/data-table/data-table.component';
import { DialogService } from '@services/dialog/dialog.service';

@Component({
    selector: 'app-dashboard-message',
    templateUrl: './dashboard-message.component.html',
    styleUrls: ['./dashboard-message.component.scss'],
    providers: [DashboardMessagesService],
    standalone: false
})
export class DashboardMessageComponent implements OnInit {

  @ViewChild(DataTableComponent) table: DataTableComponent;

  isLoading = true;
  pageActions: PageAction[];

  public columns = [{ prop: 'title' }, { prop: 'category' }, { prop: 'targetRole' }];

  constructor(
    public dashboardMessageService: DashboardMessagesService,
    public dialogService: DialogService,
    private router: Router
  ) {
  }

  ngOnInit() {
    this.createPageAction();
    this.isLoading = false;
  }

  createPageAction() {
    this.pageActions = [
      new PageAction({
        icon: 'add',
        title: 'Create dashboard message',
        callback: () => {
          this.router.navigate(['dashboard-messages', 'create']);
        }
      })
    ];
  }

  public onEdit(event: DataTableEvent) {
    this.router.navigate(['dashboard-messages', event.row._id]);
  }

  public onRemove(event: DataTableEvent) {
    this.dialogService
      .confirm('Remove dashboard message?')
      .then(res => {
        if (!res) {
          return;
        }
        return this.dashboardMessageService.remove(event.row._id).then(() => {
          this.table.refresh();
        }).catch(error => {
          const message = (error.error.message ? error.error.message : error.message);
          return this.dialogService.confirm(message, error.name);
        });
      });
  }
}
